// 🛡️ Protected Route Component
// Wraps routes that require authentication

import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import jwtTokenService from "../services/jwtTokenService";
import { toast } from "react-toastify";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = jwtTokenService.isAuthenticated();

  if (!isAuthenticated) {
    // Save the attempted location for redirect after login
    const from = location.pathname + location.search;

    // Show toast message
    toast.warning("Please login to access this page", {
      toastId: "auth-required",
    });

    // Redirect to login with return URL
    return <Navigate to="/login" state={{ from }} replace />;
  }

  // User is authenticated, render the protected content
  return children;
};

export default ProtectedRoute;
